import React, { FC } from 'react';
import { Typography } from '../../Typography';

export type FormRangeSliderLabelProps = {};

export const FormRangeSliderLabel: FC<FormRangeSliderLabelProps> = ({ children }) => {
	return <Typography variant="perex">{children}</Typography>;
};
